module.exports = "<p>\r\n  kpi-benchmarking works!\r\n</p>\r\n"